export const RESULTS_PER_PAGE_ECHEANCES = 100;
export const ACTION_REPLANNIFER = 'replanifer';
export const ACTION_LOT_PAIEMENT_CREATION = 'lotPaiementCreation';
export const ACTION_EDIT = 'modifier';

export const COLORS_CUMUL = [
  { fonce: 'is-cumulFonce1', clair: 'is-cumulClair1' },
  { fonce: 'is-cumulFonce2', clair: 'is-cumulClair2' },
  { fonce: 'is-cumulFonce3', clair: 'is-cumulClair3' },
];

export const STATUS_RAPPROCHEMENT_COMPLET = 'Complet';
export const STATUS_RAPPROCHEMENT_PARTIEL = 'Partiel';
export const STATUS_RAPPROCHEMENT_INEXISTANT = 'Inexistant';

export const LISTE_COLOR_STATUS_RAPPROCHEMENT = [
  { code: STATUS_RAPPROCHEMENT_COMPLET, color: 'is-success' },
  { code: STATUS_RAPPROCHEMENT_PARTIEL, color: 'is-warning' },
  { code: STATUS_RAPPROCHEMENT_INEXISTANT, color: 'is-danger' },
];
